const parseScriptData = (selector) => {
    const $element = $(selector);
    if ($element.length === 0) return {};
    const text = $element.html();
    if (text.trim().length === 0) return {};
    return JSON.parse(text);
};

export const load = () => {
    window.pageData = {
        ...parseScriptData('#global-page-data'),
        ...parseScriptData('#page-data')
    };
};

